import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _set from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/set";
import _getPrototypeOf from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var FunctionsError = /*#__PURE__*/function (_Error) {
  _inherits(FunctionsError, _Error);
  function FunctionsError(message) {
    var _thisSuper, _this;
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'FunctionsError';
    var context = arguments.length > 2 ? arguments[2] : undefined;
    _classCallCheck(this, FunctionsError);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(FunctionsError).call(this, message));
    _set((_thisSuper = _assertThisInitialized(_this), _getPrototypeOf(FunctionsError.prototype)), "name", name, _thisSuper, true);
    _this.context = context;
    return _this;
  }
  return FunctionsError;
}(_wrapNativeSuper(Error));
export var FunctionsFetchError = /*#__PURE__*/function (_FunctionsError) {
  _inherits(FunctionsFetchError, _FunctionsError);
  function FunctionsFetchError(context) {
    _classCallCheck(this, FunctionsFetchError);
    return _possibleConstructorReturn(this, _getPrototypeOf(FunctionsFetchError).call(this, 'Failed to send a request to the Edge Function', 'FunctionsFetchError', context));
  }
  return FunctionsFetchError;
}(FunctionsError);
export var FunctionsRelayError = /*#__PURE__*/function (_FunctionsError2) {
  _inherits(FunctionsRelayError, _FunctionsError2);
  function FunctionsRelayError(context) {
    _classCallCheck(this, FunctionsRelayError);
    return _possibleConstructorReturn(this, _getPrototypeOf(FunctionsRelayError).call(this, 'Relay Error invoking the Edge Function', 'FunctionsRelayError', context));
  }
  return FunctionsRelayError;
}(FunctionsError);
export var FunctionsHttpError = /*#__PURE__*/function (_FunctionsError3) {
  _inherits(FunctionsHttpError, _FunctionsError3);
  function FunctionsHttpError(context) {
    _classCallCheck(this, FunctionsHttpError);
    return _possibleConstructorReturn(this, _getPrototypeOf(FunctionsHttpError).call(this, 'Edge Function returned a non-2xx status code', 'FunctionsHttpError', context));
  }
  return FunctionsHttpError;
}(FunctionsError);